import UntitledIcon from '@payaca/untitled-icons';
import type { FC } from 'react';

/**
 * Replaces the {@link SortableTree} drag preview while the drop is rejected,
 * saying why.
 */
const SortableTreeDragWarning: FC<{ reason: string }> = (props) => {
  const { reason } = props;

  return (
    <div className="inline-flex max-w-full cursor-move items-center gap-2 rounded-lg bg-red-50 px-2.5 py-1.5 text-red-700 shadow-lg ring-1 ring-red-200">
      <UntitledIcon
        name="alert-triangle.3"
        className="size-5 shrink-0"
        aria-hidden
      />
      <span className="truncate">{reason}</span>
    </div>
  );
};

export default SortableTreeDragWarning;
